/**
 * @what set the default route (should be /oops/) and ?
 * @why make sure that if there are any issues with routing to the wrong place we can provide meaningful messages
 */
angular.module('utility-ng-configuration').provider('ConsistentRouteConfiguration', function ($urlRouterProvider) {
  var configuration;
  var DEFAULTS = {
    faultRoute: '/support/'
  };

  var configure = (this.configure = function configure_ConsistentRouteConfiguration(userConfig) {
    if (!!userConfig) {
      configuration = _.merge({}, DEFAULTS, userConfig);
    }

    return configuration;
  });

  this.activate = function activate_ConsistentRouteConfiguration(userConfig) {
    this.configure(userConfig);

    $urlRouterProvider.otherwise(configuration.faultRoute).rule(function ($injector, $location) {
      var $_location = $location,
        path = $_location.path(),
        search = $_location.search(),
        params;

      if (path[path.length - 1] === '/') {
        return '';
      }

      if (Object.keys(search).length === 0) {
        return path + '/';
      }

      params = _.map(search, function (v, k) {
        return k + '=' + v;
      });

      return path + '/?' + params.join('&');
    });

    return configuration;
  };

  this.$get = function () {
    return {
      configure: configure
    };
  };
});



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-configuration/src/configuration/consistent_route_configuration.js